import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../../../common/utils/logger';

export const onConvoStartersShown = (props: {
	starters: string[];
	analyticsAttributes: any;
}): AnalyticsEventPayload => {
	try {
		return {
			action: 'shown',
			actionSubject: 'aiConvoStarters',
			eventType: 'track',
			attributes: {
				...props.analyticsAttributes,
				startersCount: props.starters.length,
			},
			nonPrivacySafeAttributes: {
				starters: props.starters,
			},
		};
	} catch (error) {
		logger.error({ error, functionName: 'onConvoStarterShown' });
		return {};
	}
};
